<template>
 <div class="create-post-dialog-wrapper">
  <!-- Main Post Dialog -->
  <el-dialog :visible.sync="localVisible" custom-class="post-dialog" :show-close="true" @close="handleClose">
   <div class="dialog-content">
    <!-- Expert Info -->
    <div class="expert-info">
     <img class="expert-photo" :src="serverHostName + userProfile.picture" alt="Expert" />
     <div class="expert-details">
      <div class="expert-name">{{ userProfile.full_name }}</div>
      <div class="expert-profession">{{ userProfile.profession }}</div>
     </div>
    </div>

    <div class="mention-wrapper">
     <el-input class="post-input" type="textarea" v-model="postText" @input="onInput" placeholder="Share an Idea (Using @SYMBL)"></el-input>

     <el-select ref="selectRef" v-show="showDropdown" v-model="selectedStock" :filterable="true" :remote="true" :remote-method="filterStocks" :loading="loading" placeholder="Search stock" @change="onSelect" class="mention-dropdown" size="mini">
      <el-option v-for="item in stockList" :key="item.id" :label="item.symbol" :value="item" />
     </el-select>
    </div>

    <!-- Post Input -->
    <!-- <el-input type="textarea" :rows="2" v-model="postText" placeholder="Share an Idea (Using @SYMBL)" class="post-input"></el-input> -->

    <!-- Media Preview -->
    <div v-if="previewImages.length" class="image-preview">
     <div v-for="(img, index) in previewImages" :key="index" class="image-item">
      <img :src="img" alt="Preview" />
      <div class="remove-image-icon" @click="removeImage(index)">
       <i class="el-icon-close"></i>
      </div>
     </div>
    </div>

    <!-- PDF Preview -->
    <div v-if="selectedPDF" class="image-preview">
     <div class="image-item">
      <p>{{ selectedPDF.name }}</p>
      <div class="remove-image-icon" @click="removePDF">
       <i class="el-icon-close"></i>
      </div>
     </div>
    </div>

    <!-- Footer Buttons -->
    <div class="post-footer">
     <div class="add-media-group">
      <el-tooltip content="Add Image" placement="top">
       <div class="media-icon" @click="handleAddImage">
        <img src="@/assets/images/SACommunity/Add img Icon.svg" class="icon-img" />
       </div>
      </el-tooltip>

      <!-- <el-tooltip content="Add GIF" placement="top">
       <div class="media-icon" @click="handleAddGif">
        <img src="@/assets/images/SACommunity/GIF icon.svg" class="icon-img" />
       </div>
      </el-tooltip> -->

      <!-- <el-tooltip content="Add Document" placement="top">
       <div class="media-icon" @click="handleAddDocument">
        <img src="@/assets/images/SACommunity/Add Document (Icon).svg" class="icon-img" />
       </div>
      </el-tooltip> -->
     </div>

     <div>
      <!-- <el-button v-if="previewImages.length || selectedPDF" class="save-draft-btn" @click="saveAsDraft">Save as Draft</el-button> -->
      <el-button class="submit-btn" @click="submitCommunityPost" :loading="isPosting">Post</el-button>
     </div>
    </div>

    <!-- Hidden file inputs -->
    <input type="file" ref="imageInput" accept="image/*,.gif" @change="handleImageChange" multiple style="display: none" />
    <input type="file" ref="pdfInput" accept=".pdf" @change="handlePDFChange" style="display: none" />
   </div>
  </el-dialog>

  <!-- Success Popup Dialog -->
  <el-dialog :visible.sync="showSuccessDialog" custom-class="success-dialog" :show-close="false">
   <div class="success-content">
    <img src="@/assets/images/SuccessfulIcon.svg" class="icon-img" />
    <div class="success-message">Your Idea Has Been Posted!</div>
   </div>
  </el-dialog>
 </div>
</template>

<script>
import { serverAddr, serverAddrToUploadMediaFiles, serverHostName } from '../networkConfig';

export default {
 name: 'CreatePostDialog',
 props: {
  value: Boolean,
 },
 data() {
  return {
   postText: '',
   serverHostName: serverHostName,
   previewImages: [],
   selectedPDF: null,
   showSuccessDialog: false,
   userProfile: {},
   stock_id: 101,
   isPosting: false,
   selectedImages: [],

   //  message: '',
   selectedStock: null,
   showDropdown: false,
   stockList: [],
   //  filteredStocks: [],
   loading: false,
   searchKeyword: '',
   selected_stock_object: {},
  };
 },
 computed: {
  localVisible: {
   get() {
    return this.value;
   },
   set(val) {
    this.$emit('input', val);
   },
  },
 },

 watch: {
  // postText(newValue, oldValue){
  //   console.log(newValue);
  // }
 },

 mounted() {
  if (localStorage.getItem('profile')) {
   this.userProfile = JSON.parse(localStorage.getItem('profile'));
  }
 },
 methods: {
  onInput() {
   const words = this.postText.split(/\s/);
   const lastWord = words[words.length - 1];

   if (lastWord.startsWith('@')) {
    this.searchKeyword = lastWord.slice(1);
    this.showDropdown = true;
    this.filterStocks(this.searchKeyword);

    // Wait a bit to let DOM update, then open the dropdown
    this.$nextTick(() => {
     this.$refs.selectRef.focus(); // focus is required
     this.$refs.selectRef.toggleMenu(); // force open
    });
   } else {
    this.showDropdown = false;
   }
  },

  filterStocks(query) {
   if (!query) {
    this.stockList = [];
    return;
   }
   this.loading = true;

   this.searchStockList(query);
  },

  onSelect(stock) {
   // for multiselect
   //  const exists = this.selected_stock_object.some((item) => item.id === stock.id);
   //  if (!exists) {
   //   this.selected_stock_object.push(stock);
   //  }

   //  const words = this.postText.split(/\s/);
   //  words[words.length - 1] = '@' + stock.symbol;
   //  this.postText = words.join(' ') + ' ';
   //  this.showDropdown = false;
   //  this.selectedStock = null;

   //  console.log(this.selected_stock_object);

   //  for single select

   // Format the stock symbol
   const newMention = '@' + stock.symbol;

   // Remove all previous @stock mentions from postText
   const words = this.postText.trim().split(/\s+/);
   const filteredWords = words.filter((word) => !word.startsWith('@'));

   // Add the new selected stock at the end
   this.postText = [...filteredWords, newMention].join(' ') + ' ';

   // Update selected_stock_object to only contain the newly selected stock
   this.selected_stock_object = stock;

   // Close dropdown and clear selection
   this.showDropdown = false;
   this.selectedStock = null;

   console.log(this.postText);
   console.log(this.selected_stock_object);
  },

  searchStockList(query) {
   // this.clearAllFields();
   this.stockList = [];
   serverAddr
    .post('/recommendation/v1/read-stock', {
     search: query,
     key: 'stock',
    })
    .then((response) => {
     if (response.data.status) {
      this.loading = true;
      this.stockList = response.data.data;
     } else {
      this.stockList = [];
     }
    })
    .catch((error) => {
     this.loading = false;
     console.log('error', error);
    })
    .finally(() => {
     this.loading = false;
    });
  },

  handleAddImage() {
   if (this.selectedPDF) {
    this.$message.warning('You can’t select images/GIFs when a document is selected.');
    return;
   }
   this.$refs.imageInput.click();
  },
  // handleAddGif() {
  //  if (this.selectedPDF) {
  //   this.$message.warning('You can’t select images/GIFs when a document is selected.');
  //   return;
  //  }
  //  this.$refs.imageInput.click();
  // },
  // handleAddDocument() {
  //  if (this.previewImages.length > 0) {
  //   this.$message.warning('You can’t select a document when images/GIFs are selected.');
  //   return;
  //  }
  //  if (this.selectedPDF) {
  //   this.$message.warning('Only one document can be selected.');
  //   return;
  //  }
  //  this.$refs.pdfInput.click();
  // },
  handleImageChange(event) {
   const files = Array.from(event.target.files);

   this.selectedImages.push(...files);

   if (files.length + this.previewImages.length > 10) {
    this.$message.error('You can only select up to 10 images or GIFs.');
    return;
   }
   files.forEach((file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
     this.previewImages.push(e.target.result);
    };
    reader.readAsDataURL(file);
   });
  },
  handlePDFChange(event) {
   const file = event.target.files[0];
   if (file) {
    this.selectedPDF = file;
   }
  },
  removeImage(index) {
   this.previewImages.splice(index, 1);
   this.selectedImages.splice(index, 1);
  },
  removePDF() {
   this.selectedPDF = null;
  },
  // saveAsDraft() {
  //  console.log('Saved as draft:', {
  //   text: this.postText,
  //   images: this.previewImages,
  //   document: this.selectedPDF,
  //  });
  //  this.$message.success('Post saved as draft!');
  // },

  submitCommunityPost() {
   if (!this.postText.trim()) {
    this.$message.warning('Please enter some text before posting.');
    return;
   }

   if (this.isPosting) return;

   //  this.isPosting = trueu

   let formData = new FormData();

   formData.append('stock_id', this.stock_id);
   formData.append('post', this.postText);

   this.selectedImages.forEach((file) => {
    formData.append('attachments', file);
   });

   if (Object.keys(this.selected_stock_object).length > 0) {
    formData.append('stock_id', this.selected_stock_object.id);
   }
   //  if (this.selectedPDF) {
   //   formData.append('attachments', this.selectedPDF);
   //  }

   console.log(formData, 'formDataformDataformDataformData');

   serverAddrToUploadMediaFiles
    .post('/community/community-post', formData)
    .then((response) => {
     if (response.data.status) {
      this.showSuccessDialog = true;
      this.localVisible = false;

      setTimeout(() => {
       this.showSuccessDialog = false;
       this.resetForm();
      }, 2500);
      this.postText = '';
     }
    })
    .catch((error) => {
     console.error('Community post error:', error);
     this.$message.error('Something went wrong. Please try again.');
    })
    .finally(() => {
     this.isPosting = false;
     this.postText = '';
    });
  },

  resetForm() {
   this.postText = '';
   this.previewImages = [];
   this.selectedPDF = null;
   this.searchKeyword = '';
   this.selected_stock_object = {};
  },
  handleClose() {
   this.$emit('input', false);
  },
 },
};
</script>

<style lang="scss" scoped>
.create-post-dialog-wrapper {
 ::v-deep .post-dialog {
  border-radius: 10px !important;
  width: 700px !important;
  top: 40px !important;

  .el-dialog__header {
   padding: 0px;
  }

  @media screen and (max-width: 768px) {
   width: 95% !important;
   margin: 0 auto;
  }
 }

 .dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .expert-info {
   display: flex;
   align-items: center;
   gap: 12px;

   .expert-photo {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
   }

   .expert-details {
    .expert-name {
     font-weight: bold;
     font-size: 16px;
    }

    .expert-profession {
     font-size: 14px;
     color: #888;
    }
   }
  }

  .post-input {
   ::v-deep .el-textarea__inner {
    border: none !important;
    resize: none;
    font-size: 15px;
    font-weight: 500;
    color: #939393;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;
   }
  }

  .image-preview {
   display: flex;
   flex-wrap: wrap;
   gap: 10px;

   .image-item {
    position: relative;
    width: 100px;
    height: 100px;

    img {
     width: 100%;
     height: 100%;
     object-fit: cover;
     border-radius: 8px;
    }

    p {
     font-size: 14px;
     font-weight: 500;
     word-break: break-word;
    }

    .remove-image-icon {
     position: absolute;
     top: 4px;
     right: 4px;
     background: rgba(0, 0, 0, 0.6);
     border-radius: 50%;
     padding: 4px;
     cursor: pointer;
     color: #fff;
     font-size: 14px;

     &:hover {
      background: rgba(0, 0, 0, 0.8);
     }
    }
   }
  }

  .post-footer {
   display: flex;
   justify-content: space-between;
   align-items: center;

   .add-media-group {
    display: flex;
    align-items: center;
    gap: 12px;

    .media-icon {
     cursor: pointer;

     .icon-img {
      width: 24px;
      height: 24px;
     }
    }
   }

   .save-draft-btn {
    background-color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    color: #2d2e8d;
    border-radius: 50px;
    padding: 12px 25px;
    margin-right: 10px;
    border: 1px solid #2d2e8d;
   }

   .submit-btn {
    background: linear-gradient(90deg, #2d2e8d 0%, #0c0d27 100%);
    font-size: 13px;
    font-weight: 600;
    border-radius: 50px;
    color: #ffffff;
    padding: 12px 25px;
   }
  }
 }

 ::v-deep .success-dialog {
  border-bottom: 5px solid #0ba042 !important;
  border-radius: 10px !important;
  text-align: center;
  width: 400px !important;
  .el-dialog__header {
   display: none;
  }

  .el-dialog__body {
   padding: 30px 20px;

   .success-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    .success-icon {
     font-size: 40px;
     color: #0ba042;
    }

    .success-message {
     font-size: 18px;
     font-weight: bold;
     color: #333;
    }
   }
  }

  @media screen and (max-width: 450px) {
   width: 300px !important;
  }
 }
}
</style>
<style scoped>
.mention-wrapper {
 position: relative;
 width: 100%;
}

.mention-dropdown {
 position: absolute;
 top: 60px; /* Adjust based on your input height */
 left: 10px;
 width: 200px;
 z-index: 1000;
}
</style>

<!-- <style scoped>
.mention-wrapper {
  position: relative;
}

.mention-dropdown {
  position: absolute;
  top: 60px;
  left: 10px;
  width: 220px;
  z-index: 999;
}
</style> -->